import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Api } from '../../utils/api';

export interface LoginRequest {
    ocr: string;
    zipCode: string;
}

export interface LoginResponse {
    success: boolean;
    missing: boolean;
    isPerson: boolean;
    error: string;
    invoiceId?: string;
    isAtivoCore: boolean;
}

const baseUrl = process.env.REACT_APP_KEEROS_API_URL;

export async function invoiceExists(request: LoginRequest): Promise<LoginResponse> {
    const url = `${baseUrl}/keerosinvoiceexists`;
    try {
        const response = await Api.post<BodyInit, LoginResponse>(url, JSON.stringify(request));
        return response;
    } catch (error) {
        return {
            success: false,
            isPerson: false,
            error: error,
        } as LoginResponse;
    }
}

// Define a service using a base URL and expected endpoints
export const loginApi = createApi({
    reducerPath: 'loginApi',
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl
    }),
    endpoints: (builder) => ({
        login: builder.query<LoginResponse, LoginRequest>({
            query: (request) => ({
                url: 'keerosinvoiceexists',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: {
                    ocr: request.ocr,
                    zipCode: request.zipCode,
                },
            }),
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLazyLoginQuery } = loginApi;
